import React, { useState, useEffect } from 'react'
import './common.css'
import API_URL from '../common/Apiurl';
import { Link  } from "react-router-dom"
import { AiTwotoneEdit } from "react-icons/ai";

function Credit(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    useEffect(() => {
        const getValues = async() =>{
            try{
                const result = await fetch(`${apiUrl}/admin/creditdetails`,{
                    method: 'GET',
                    headers: {
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                });
                const data = await result.json();
                setItems(data.response);
            }
            catch(error){
                console.log('Error: ', error)
            }
        }
        getValues();
    },[]);
    return (
            <div className='width90'>
                <div className='row'>
                    <div className='col-sm-6'>
                        <h2 className='pageTitle'>Credit for transaction type</h2>
                    </div>
                </div>
                {/* excelsheet */}
                <div className="form-group cmnwhitebg pt-4 pb-4">
                    <div className='row'>
                        <div className='col-sm-3 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Users Type </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Create Job </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Apply Job </label>                            
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Coins </label>                        
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Action </label>
                        </div>
                    </div>
                    <div className='row mt-3 rowBorder'>
                        <div className='col-sm-3 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Homeowner </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.create_job_homeowner} </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">0 </label>                            
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.coin_conversion} </label>                        
                        </div>
                        <div className='col-sm-2 text-center'>
                            <Link to={`/admin/credit/editcredit/1`} className='view float-none'><AiTwotoneEdit /></Link>
                        </div>
                    </div>
                    <div className='row rowBorder'>
                        <div className='col-sm-3 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Employer </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.create_job_employer} </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.apply_job_employer} </label>                            
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.coin_conversion} </label>                        
                        </div>
                        <div className='col-sm-2 text-center'>
                            <Link to={`/admin/credit/editcredit/2`} className='view float-none'><AiTwotoneEdit /></Link>
                        </div>
                    </div>
                    <div className='row rowBorder'>
                        <div className='col-sm-3 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Provider </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">0 </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.apply_job_provider} </label>                            
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.coin_conversion} </label>                        
                        </div>
                        <div className='col-sm-2 text-center'>
                            <Link to={`/admin/credit/editcredit/3`} className='view float-none'><AiTwotoneEdit /></Link>
                        </div>
                    </div>
                    <div className='row rowBorder'>
                        <div className='col-sm-3 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">Cash Conversion Rate </label>
                        </div>
                        <div className='col-sm-2 text-center'>
                            {/* <label className="control-label col-sm-10 label" htmlFor="exportData">0 </label> */}
                        </div>
                        <div className='col-sm-2 text-center'>
                            {/* <label className="control-label col-sm-10 label" htmlFor="exportData">{items.apply_job_provider} </label>                             */}
                        </div>
                        <div className='col-sm-2 text-center'>
                            <label className="control-label col-sm-10 label" htmlFor="exportData">{items.cash_conversion} </label>                        
                        </div>
                        <div className='col-sm-2 text-center'>
                            <Link to={`/admin/credit/editcredit/4`} className='view float-none'><AiTwotoneEdit /></Link>
                        </div>
                    </div>
                </div>
                {/* excelsheet */}
            </div>
    )
}

export default Credit;